import { BRAND_NAME, BRAND_URL, EMAIL_ADDRESS } from '../Globals';
import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { UserMenu } from './UserMenu';
import { User } from 'application/User';
import { Loadable } from 'LoadingState';

export interface HeaderProps {
    children: React.ReactNode;
    user: Loadable<User>;
}

export interface HeaderState {

}

export class Header extends React.Component<HeaderProps, HeaderState> {

    constructor(props: Readonly<HeaderProps>) {
        super(props);
    }

    /* TODO
                        Phone number / request support
                            Chat
                            Feedback
                        Search
                        Busy / completed actions (show progress, logs, retrieve results).
                        Messages (alerts)
                            Notification settings
                        Profile (account, settings, log out)
                            Preferences (dark mode, date format)
                            Select country (support phone no, language, locale)

                    */

    render() {
        return (
            <header className='header-wrapper'>

                <div className='header-group'>
                    {/*<Link to={BRAND_URL} className='headerItem'>{BRAND_NAME}</Link>*/}
                    <span className='headerItem'>{BRAND_NAME}</span>
                    <span style={{ marginLeft: '1em' }} /> {/*TODO - proper layout*/}
                    <div className='headerItem'>{this.props.children}</div>
                </div>

                {/*
                <div className='header-group'>
                    <a className='clickableHeaderItem' href={`mailto:${EMAIL_ADDRESS}`}>📧 Feedback</a>
                    <span style={{ marginLeft: '1em' }} />
                    <a className='clickableHeaderItem'><UserMenu user={this.props.user}/></a>
                </div>*/
                }
            </header>
        );
    }


}
